import React, { useEffect, useState } from "react";
import { useMaterialUIController, setDirection } from "context";

import {
  Box,
  Card,
  CardContent,
  Typography,
  Chip,
  Grid,
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Badge,
  Container,
  ThemeProvider,
  createTheme,
  CssBaseline,
  CircularProgress,
} from "@mui/material";
import { useGetStoreInfoQuery } from "../../redux/Slices/storeInfoApi";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import AddIcon from "@mui/icons-material/Add";
import SubscriptionForm from "./SubscriptionForm";

const theme = createTheme({
  palette: {
    primary: {
      main: "#667eea",
    },
    secondary: {
      main: "#764ba2",
    },
    success: {
      main: "#10b981",
    },
    warning: {
      main: "#f59e0b",
    },
  },
  typography: {
    fontFamily: "Roboto, sans-serif",
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
          transition: "transform 0.2s ease-in-out",
          "&:hover": {
            transform: "translateY(-4px)",
          },
        },
      },
    },
  },
});

const ShowSupscriptionDetails = () => {
  const { data, isLoading, error } = useGetStoreInfoQuery();
  console.log("🚀 ~ ShowSupscriptionDetails ~ data:", data);
  const [controller, dispatch] = useMaterialUIController();
  const [subscriptionmodelOpen, setSubscriptionModalOpen] = useState(false);
  useEffect(() => {
    setDirection(dispatch, "rtl");

    return () => setDirection(dispatch, "ltr");
    // eslint-disable-next-line
  }, []);

  if (isLoading) {
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <CircularProgress />
    </Box>;
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const getDaysRemaining = (endDate) => {
    const today = new Date();
    const end = new Date(endDate);
    const diffTime = end - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const daysRemaining = getDaysRemaining(data?.data?.store?.subscription?.end_date);

  return (
    <>
      {data && (
        <DashboardLayout>
          {subscriptionmodelOpen && (
            <SubscriptionForm
              open={subscriptionmodelOpen}
              onClose={() => setSubscriptionModalOpen(false)}
            />
          )}
          <DashboardNavbar />
          <MDBox pt={6} pb={3}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                borderRadius="lg"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                  boxShadow: 3,
                }}
              >
                <MDTypography variant="h6" color="white">
                  تفاصيل الاشتراك
                </MDTypography>

                <MDButton
                  variant="contained"
                  color="white"
                  startIcon={<AddIcon />}
                  sx={{ color: "white" }}
                  onClick={() => setSubscriptionModalOpen(true)}
                >
                  ترقية الاشتراك
                </MDButton>
              </MDBox>

              <ThemeProvider theme={theme}>
                <CssBaseline />
                <Box
                  sx={{
                    minHeight: "100vh",
                    // background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    py: 4,
                  }}
                >
                  {/* Header */}
                  <Container maxWidth="lg">
                    {/* Store Info & Status */}
                    <Box container spacing={3} sx={{ mb: 4, display: "flex", gap: 2 }}>
                      <Box item xs={12}>
                        <Card
                          sx={{
                            /* background: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)", */
                            background:
                              "linear-gradient(135deg, #9e7831, #d1a042,#ca9937, #eac282)",

                            color: "white",
                            textAlign: "center",
                            height: "100%",
                          }}
                        >
                          <CardContent sx={{ p: 3 }}>
                            <Avatar
                              src={data?.data?.store?.logo}
                              alt={data?.data?.store?.name_en}
                              sx={{
                                width: 80,
                                height: 80,
                                mx: "auto",
                                mb: 2,
                                border: "3px solid rgba(255,255,255,0.3)",
                              }}
                            />
                            <Typography
                              variant="h5"
                              component="h2"
                              gutterBottom
                              sx={{ fontWeight: "bold" }}
                            >
                              {data?.data?.store.name_en}
                            </Typography>
                            <Typography variant="h6" sx={{ mb: 2, opacity: 0.9 }}>
                              {data?.data?.store.name_ar}
                            </Typography>

                            <Stack spacing={1} alignItems="center">
                              <Box sx={{ display: "flex", alignItems: "center" }}>
                                <i
                                  className="material-icons"
                                  style={{ marginRight: 8, fontSize: 18 }}
                                >
                                  store
                                </i>
                                <Typography variant="body2">ID: {data?.data?.store?.id}</Typography>
                              </Box>
                              <Typography variant="body2">{data?.data?.store.phone}</Typography>
                              <Typography variant="body2">{data?.data?.store.email}</Typography>
                            </Stack>
                          </CardContent>
                        </Card>
                      </Box>

                      <Box item xs={12} md={8} sx={{ flex: 1 }}>
                        <Card sx={{ height: "100%" }}>
                          <CardContent sx={{ p: 3 }}>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mb: 3,
                              }}
                            >
                              <Typography
                                variant="h5"
                                sx={{
                                  background:
                                    "linear-gradient(90deg, #382a11, #6b5121, #9e7831, #d1a042)",
                                  WebkitBackgroundClip: "text",
                                  backgroundClip: "text",
                                  WebkitTextFillColor: "transparent",
                                  color: "transparent",
                                  fontWeight: "bold",
                                }}
                              >
                                تفاصيل الاشتراك
                              </Typography>
                              <Chip
                                icon={<i className="material-icons text-white ">check_circle</i>}
                                label={data?.data?.store?.subscription?.status.toUpperCase()}
                                color="success"
                                sx={{ fontWeight: "bold", color: "white" }}
                              />
                            </Box>

                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={6}>
                                <Paper
                                  elevation={1}
                                  sx={{ p: 2, borderRadius: 2, bgcolor: "#f8fafc" }}
                                >
                                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                    <i
                                      className="material-icons"
                                      style={{ marginRight: 8, color: "#4a5568" }}
                                    >
                                      event
                                    </i>
                                    <Typography variant="body2" ml={1} color="text.secondary">
                                      بداية الاشتراك
                                    </Typography>
                                  </Box>
                                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                    {formatDate(data?.data?.store?.subscription?.start_date)}
                                  </Typography>
                                </Paper>
                              </Grid>

                              <Grid item xs={12} sm={6}>
                                <Paper
                                  elevation={1}
                                  sx={{ p: 2, borderRadius: 2, bgcolor: "#f8fafc" }}
                                >
                                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                    <i
                                      className="material-icons"
                                      style={{ marginRight: 8, color: "#4a5568" }}
                                    >
                                      event_busy
                                    </i>
                                    <Typography variant="body2" ml={1} color="text.secondary">
                                      نهاية الاشتراك
                                    </Typography>
                                  </Box>
                                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                    {formatDate(data?.data?.store?.subscription?.end_date)}
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    color="warning.main"
                                    sx={{ fontWeight: "bold" }}
                                  >
                                    {daysRemaining > 0
                                      ? ` الايام المتبقية ${daysRemaining} يوم`
                                      : "Expired"}
                                  </Typography>
                                </Paper>
                              </Grid>

                              <Grid item xs={12} sm={6}>
                                <Paper
                                  elevation={1}
                                  sx={{ p: 2, borderRadius: 2, bgcolor: "#f8fafc" }}
                                >
                                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                    <i
                                      className="material-icons"
                                      style={{ marginRight: 8, color: "#4a5568" }}
                                    >
                                      autorenew
                                    </i>
                                    <Typography variant="body2" ml={1} color="text.secondary">
                                      التجديد
                                    </Typography>
                                  </Box>
                                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                    {data?.data?.store?.subscription?.auto_renew
                                      ? "تلقائي"
                                      : "يدوي"}
                                  </Typography>
                                </Paper>
                              </Grid>

                              <Grid item xs={12} sm={6}>
                                <Paper
                                  elevation={1}
                                  sx={{ p: 2, borderRadius: 2, bgcolor: "#f8fafc" }}
                                >
                                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                    <i
                                      className="material-icons"
                                      style={{ marginRight: 8, color: "#4a5568" }}
                                    >
                                      confirmation_number
                                    </i>
                                    <Typography variant="body2" ml={1} color="text.secondary">
                                      رقم الاشتراك
                                    </Typography>
                                  </Box>
                                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                    #{data?.data?.store?.subscription?.id}
                                  </Typography>
                                </Paper>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Box>
                    </Box>

                    {/* Plan Details */}
                    <Card>
                      <CardContent sx={{ p: 3 }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 3,
                          }}
                        >
                          <Box>
                            <Box sx={{ display: "flex", gap: 2 }}>
                              <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                                الخطة :
                              </Typography>
                              <Typography
                                variant="h5"
                                sx={{
                                  background: "linear-gradient(90deg, #6b5121, #9e7831, #d1a042)",
                                  WebkitBackgroundClip: "text",
                                  backgroundClip: "text",
                                  WebkitTextFillColor: "transparent",
                                  color: "transparent",
                                  fontWeight: "bold", // Medium weight, like Tailwind's font-medium
                                  // Equivalent to Tailwind's text-lg
                                  // Matches MUI's body1
                                }}
                              >
                                {data?.data?.store?.plan[0]?.name}
                              </Typography>
                            </Box>
                            <Typography
                              variant="h6"
                              sx={{
                                background:
                                  "linear-gradient(90deg, #382a11, #6b5121, #9e7831, #d1a042)",
                                WebkitBackgroundClip: "text",
                                backgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                color: "transparent",
                                fontWeight: "bold",
                              }}
                            >
                              ${data?.data?.store?.plan[0]?.price}/
                              {data?.data?.store?.plan[0]?.billing_cycle ? "شهريا" : "سنويا"}
                            </Typography>
                          </Box>
                        </Box>

                        <Divider sx={{ my: 2 }} />

                        <Grid container spacing={3}>
                          {/* Plan Limits */}
                          <Grid item xs={12} md={6}>
                            <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
                              حدود الخطة
                            </Typography>
                            <List dense>
                              <ListItem>
                                <ListItemIcon>
                                  <i className="material-icons" style={{ color: "#111111" }}>
                                    inventory
                                  </i>
                                </ListItemIcon>
                                <ListItemText
                                  primary="المنتجات"
                                  secondary={`حتي ${data?.data?.store?.plan[0]?.product_limit} منتج`}
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemIcon>
                                  <i className="material-icons" style={{ color: "#111111" }}>
                                    campaign
                                  </i>
                                </ListItemIcon>
                                <ListItemText
                                  primary="العروض"
                                  secondary={`${data?.data?.store?.plan[0]?.offers_limit} ${data?.data?.store?.plan[0]?.offers_system} عروض`}
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemIcon>
                                  <i className="material-icons" style={{ color: "#111111" }}>
                                    ads_click
                                  </i>
                                </ListItemIcon>
                                <ListItemText
                                  primary="الاعلانات"
                                  secondary={`${data?.data?.store?.plan[0]?.ads_limit} ${data?.data?.store?.plan[0]?.ads_system} اعلانات`}
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemIcon>
                                  <i className="material-icons" style={{ color: "#111111" }}>
                                    shopping_cart
                                  </i>
                                </ListItemIcon>
                                <ListItemText
                                  primary="الطلبات"
                                  secondary={`حتي ${data?.data?.store?.plan[0]?.orders_limit} طلب`}
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemIcon>
                                  <i className="material-icons" style={{ color: "#111111" }}>
                                    people
                                  </i>
                                </ListItemIcon>
                                <ListItemText
                                  primary="المستخدمين"
                                  secondary={`حتي ${data?.data?.store?.plan[0]?.users_limit} مستخدم`}
                                />
                              </ListItem>
                            </List>
                          </Grid>

                          {/* Services */}
                          <Grid item xs={12} md={6}>
                            <Typography
                              variant="h6"
                              mb={3}
                              gutterBottom
                              sx={{ fontWeight: "bold" }}
                            >
                              الخدمات المتاحة
                            </Typography>

                            <Box sx={{ mb: 2 }}>
                              <Box sx={{ display: "flex", gap: 1 }}>
                                <i className="material-icons" style={{ marginRight: 8 }}>
                                  local_shipping
                                </i>
                                <Typography
                                  variant="subtitle2"
                                  gutterBottom
                                  ml={1}
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  شركات الشحن
                                </Typography>
                              </Box>
                              <Stack direction="row" ml={5} spacing={1} flexWrap="wrap" useFlexGap>
                                {data?.data?.store?.plan[0]?.shipping_companies.map((company) => (
                                  <Chip
                                    key={company}
                                    label={company}
                                    size="small"
                                    variant="outlined"
                                  />
                                ))}
                              </Stack>
                            </Box>

                            <Box sx={{ mb: 2 }}>
                              <Box sx={{ display: "flex", gap: 1 }}>
                                <i className="material-icons" style={{ marginRight: 8 }}>
                                  payment
                                </i>
                                <Typography
                                  variant="subtitle2"
                                  gutterBottom
                                  sx={{ display: "flex", alignItems: "center" }}
                                  ml={1}
                                >
                                  وسائل الدفع
                                </Typography>
                              </Box>
                              <Stack direction="row" ml={5} spacing={1} flexWrap="wrap" useFlexGap>
                                {data?.data?.store?.plan[0]?.payment_gateways.map((gateway) => (
                                  <Chip
                                    key={gateway}
                                    label={gateway}
                                    size="small"
                                    variant="outlined"
                                  />
                                ))}
                              </Stack>
                            </Box>

                            <Box sx={{ mb: 2 }}>
                              <Box sx={{ display: "flex", gap: 1 }}>
                                <i className="material-icons" style={{ marginRight: 8 }}>
                                  support_agent
                                </i>
                                <Typography
                                  variant="subtitle2"
                                  gutterBottom
                                  sx={{ display: "flex", alignItems: "center" }}
                                  ml={1}
                                >
                                  الدعم الفني
                                </Typography>
                              </Box>
                              <Stack direction="row" ml={5} spacing={1} flexWrap="wrap" useFlexGap>
                                {data?.data?.store?.plan[0]?.technical_support.map((support) => (
                                  <Chip
                                    key={support}
                                    label={support}
                                    size="small"
                                    color="secondary"
                                  />
                                ))}
                              </Stack>
                            </Box>

                            <Box>
                              <Box sx={{ display: "flex", gap: 1 }}>
                                <i className="material-icons" style={{ marginRight: 8 }}>
                                  percent
                                </i>
                                <Typography
                                  variant="subtitle2"
                                  gutterBottom
                                  sx={{ display: "flex", alignItems: "center" }}
                                  ml={1}
                                >
                                  عمولة البيع: {data?.data?.store?.plan[0]?.sales_commission}%
                                </Typography>
                              </Box>
                              <Typography variant="body2" ml={5} color="text.secondary">
                                مدة التجربة: {data?.data?.store?.plan[0]?.trial_days} days
                              </Typography>
                            </Box>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Container>
                </Box>
              </ThemeProvider>
            </Card>
          </MDBox>
        </DashboardLayout>
      )}
    </>
  );
};

export default ShowSupscriptionDetails;
